<template lang="pug">
table#work-breaks-report-table.table-hover.reports-table.work-breaks-report-table.table
  WorkBreaksReportTableHeader

  ReportVirtualTableBody(
    v-slot="{ row: section }"
    :rows="sections"
  )
    tr.grouping-header
      th(colspan="100%")
        template(v-if="walker.main_type === 'user'")
          MemberPaymentAccountPopup(
            :organization-id="organization.id"
            :user-id="section.main_id"
            :image-url="section.rows[0].record.avatar_url"
            :name="section.main"
            :show-member-profile="showMemberProfile"
            tab="settings"
            title=""
          )
        template(v-else-if="walker.main_type === 'work_break_policy'")
          | {{ section.main || 'No Break Policy' }}
        template(v-else-if="walker.main_type === 'date'")
          | {{ formatDateLabel(section.main) }}
        template(v-else)
          | {{ section.main }}
    tr.ttotal.within-virtual.cursor-pointer(
      :class="{ 'is-expanded': section.show }"
      @click="toggleSection(section)"
    )
      th
        span.expand-rows-toggle(:class="{ 'is-expanded': section.show }")
          i.hi.hi-caret
          | Total
      td(v-if="walker.sub_show")
      td(v-if="tableShowStatus")
      td(v-if="tableShowStartsAt")
      td(v-if="tableShowStopsAt")
      td(v-if="tableShowAllotted") {{ formatDuration(section.total.policy_duration) }}
      td(v-if="tableShowActualLength") {{ formatDuration(section.total.actual_duration) }}
      td(v-if="tableShowPaidLength") {{ formatDuration(section.total.paid_duration) }}
    ReportVirtualTableBody(
      v-if="section.show"
      :key="`table-${section.uuid}`"
      v-slot="{ row }"
      :rows="section.rows"
      :item-size="section.itemSize"
      nested
    )
      tr
        td(v-if="walker.sub_show")
          template(v-if="walker.sub_type === 'date'")
            | {{ formatDateLabel(row.record.sub) }}
          template(v-else-if="walker.sub_type === 'user'")
            MemberPaymentAccountPopup(
              :organization-id="organization.id"
              :user-id="row.record.sub_id"
              :image-url="row.record.avatar_url"
              :name="row.record.sub"
              :show-member-profile="showMemberProfile"
              tab="settings"
              title=""
            )
          template(v-else-if="walker.sub_type === 'work_break_policy'")
            | {{ row.record.sub }}
          template(v-else)
            | {{ row.record.sub }}

        td(v-if="row.third_show_data")
          template(v-if="walker.third_type === 'date'")
            | {{ formatDateLabel(row.record.third) }}
          template(v-else-if="walker.third_type === 'user'")
            ReportTableAvatar(
              :user-id="row.record.third_id"
              :url="row.record.avatar_url"
            )
            | {{ row.record.third }}
          template(v-else-if="walker.third_type === 'work_break_policy'")
            ReportTableAvatarInitial(
              :text="row.record.third"
              class-modifier="avatar"
            )
            | {{ row.record.third }}
          template(v-else)
            | {{ row.record.third }}
        td(v-else)

        td(v-if="tableShowStatus") {{ statusName(row.record.status) }}
        td(v-if="tableShowStartsAt")
          template(v-if="hasWorkBreakStatuses && !isMissedStatus(row.record.status)")
            | {{ formattedTime(row.record.starts_at) }}
          template(v-else) -
        td(v-if="tableShowStopsAt")
          template(v-if="hasWorkBreakStatuses && !isMissedStatus(row.record.status)")
            | {{ formattedTime(row.record.stops_at) }}
          template(v-else) -
        td(v-if="tableShowAllotted") {{ $filters.formatDuration(row.record.policy_duration, 'auto', null, false, true) }}
        td(v-if="tableShowActualLength") {{ $filters.formatDuration(row.record.actual_duration, 'auto', null, false, true) }}
        td(v-if="tableShowPaidLength")
          template(v-if="row.record.paid_duration")
            | {{ $filters.formatDuration(row.record.paid_duration, 'auto', null, false, true) }}
          template(v-else) -
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import { formatTime, formatDuration } from '~/utils/time_utils';
import MemberPaymentAccountPopup from '~/components/financials/MemberPaymentAccountPopup.vue';
import ReportVirtualTableBody from '~/components/reports/ReportVirtualTableBody.vue';
import WorkBreaksReportTableHeader from './WorkBreaksReportTableHeader.vue';

export default {
  name: 'WorkBreaksReportTable',
  components: {
    MemberPaymentAccountPopup,
    ReportVirtualTableBody,
    WorkBreaksReportTableHeader,
  },
  props: {
    tableData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters([
      'walker',
      'showToggledSectionById',
      'tableShowStatus',
      'tableShowStartsAt',
      'tableShowStopsAt',
      'tableShowAllotted',
      'tableShowActualLength',
      'tableShowPaidLength',
      'workBreakStatuses',
      'showMemberProfile',
      'virtualTableItemSize',
    ]),
    ...mapState({
      organization: 'organization',
    }),
    hasWorkBreakStatuses() {
      return this.workBreakStatuses && this.workBreakStatuses.length;
    },
    sections() {
      return this.tableData.sections.map((section) => {
        return {
          ...section,
          show: this.showToggledSectionById(section.main_id),
          itemSize: this.virtualTableItemSize,
        };
      });
    },
  },
  methods: {
    toggleSection(section) {
      this.$store.dispatch('toggleSection', {
        section_id: section.main_id,
        section_count: this.tableData.sections.length,
      });
    },
    formatDateLabel(value) {
      if (value === 'summed_date') {
        return (
          TimeUtils.format_date(TimeUtils.parse_internal_date(this.$store.state.report_query.date)) +
          ' - ' +
          TimeUtils.format_date(TimeUtils.parse_internal_date(this.$store.state.report_query.date_end))
        );
      }

      return TimeUtils.format_date(TimeUtils.parse_internal_date(value));
    },
    statusName(id) {
      if (this.hasWorkBreakStatuses) {
        const status = this.workBreakStatuses.find((s) => s.id === id);

        return status ? status.text : 'N/A';
      }

      return '-';
    },
    isMissedStatus(status) {
      return this.statusName(status).toLowerCase() === 'missed';
    },
    formattedTime(time) {
      return formatTime(time, {
        showSeconds: 'user',
        timezone: this.organization.time_zone_name,
      });
    },
    formatDuration(duration, options = {}) {
      return formatDuration(duration, { blank: '—', ...options });
    },
  },
};
</script>
